import { configureStore } from '@reduxjs/toolkit';
import appReducer from './appSlice';
import authReducer from './authSlice';

export const store = configureStore({
    reducer: {
        app: appReducer,
        auth: authReducer,
    },
});

const saveState = (state) => {
    try {
        const serializedState = JSON.stringify(state);
        localStorage.setItem('ejdh_admin_state', serializedState);
    } catch (e) {
        // Ignore write errors;
    }
};

store.subscribe(() => {
    console.log('store.getState()', store.getState());
    saveState(store.getState());
});
